import { useState, useCallback } from 'react'
import { fetchData } from '../helpers/fetchData'

const useFetchData = () => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const clearData = useCallback(() => setData(null), [])

  const executeFetch = useCallback(async (method, url, payload = {}) => {
    setLoading(true)
    const result = await fetchData(method, url, payload)

    result ? setData(result) : setData(null)
    setLoading(false)
    return result
  }, [])

  return { data, loading, executeFetch, clearData }
}

export default useFetchData
